import React, { Component } from 'react';

class InfoTile extends Component {
  constructor(props) {
    super(props);
    this.state = {hover: false};
    this.mouseOver = this.mouseOver.bind(this);
    this.mouseOut = this.mouseOut.bind(this);
  }

  mouseOver = () => {
    this.setState({hover: true});
  }
  mouseOut() {
      this.setState({hover: false});
  }

  render() {
    return (
      <div className="info-tile">
        <a href={this.props.href} target="_blank">
          <img src={this.props.imagePath} onMouseOver={this.mouseOver.bind(this)} onMouseOut={this.mouseOut.bind(this)} role="presentation"></img>
        </a>
        <div className="info-title">
          {this.props.title}{this.props.date ? ' - ' : ''}{this.props.date}
        </div>
        <div className="info-description">
          {this.props.description}
        </div>
      </div>
    );
  }
}

export default InfoTile;



// WEBPACK FOOTER //
// ./src/js/InfoTile.js